import { render, staticRenderFns } from "./AddPlan.vue?vue&type=template&id=50b01b82&scoped=true&"
import script from "./AddPlan.vue?vue&type=script&lang=js&"
export * from "./AddPlan.vue?vue&type=script&lang=js&"
import style0 from "./AddPlan.vue?vue&type=style&index=0&id=50b01b82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b01b82",
  null
  
)

export default component.exports